import { FPAData } from '../../../../infra/protected/FPA/FPAData';

/**
 * Calculates the maximum depth of expanded nodes in the tree.
 * Since treeData is a flat array representing the visible expanded tree,
 * we simply find the maximum node_level value.
 * 
 * @param treeData - Flat array of FPAData items representing the visible expanded tree
 * @returns Maximum depth (node_level) found in the tree, or 0 if tree is empty
 */
export function getMaxExpandedDepth(treeData: FPAData[]): number {
  if (!treeData || treeData.length === 0) return 0;
  
  // Since treeData is flat and represents visible expanded tree,
  // we can simply find the max node_level
  return Math.max(...treeData.map(item => item.node_level || 0));
}
